import { Image } from 'native-base'
import { useRef } from 'react'
import { ImageStyle, StyleProp } from 'react-native'

import { isExpoGo } from '~constants'
import { useDeviceInfo, useMemo } from '~hooks'
import { Images } from '~images'

type RemoteImageProps = {
  uri: string
  style: StyleProp<ImageStyle>
  resizeMode: 'cover' | 'contain' | 'stretch' | 'center'
  alt?: string
  fallbackSource?: number
}

const FALLBACK_IMAGE = Images.OFFER_IMAGE_PLACEHOLDER

export const RemoteImage = ({
  alt = '',
  fallbackSource = FALLBACK_IMAGE,
  resizeMode = 'cover',
  style = {},
  uri,
}: RemoteImageProps): JSX.Element => {
  const { isWeb } = useDeviceInfo()
  const fastImageRef = useRef<JSX.Element | null>(null)
  if (!isExpoGo && uri && !isWeb) {
    import('react-native-fast-image').then(({ default: FastImage }) => {
      fastImageRef.current = (
        <FastImage
          defaultSource={fallbackSource}
          resizeMode={resizeMode}
          source={{ uri, priority: 'high' }}
          // @ts-expect-error - FastImage dynamically import doesn't see it as proper type
          style={style}
        />
      )
    })
  }

  const renderNBImage = useMemo(
    () => (
      <Image
        alt={alt}
        fallbackSource={fallbackSource}
        resizeMode={resizeMode}
        source={uri ? { uri } : fallbackSource}
        style={style}
      />
    ),
    [alt, fallbackSource, resizeMode, uri, style]
  )
  return fastImageRef.current || renderNBImage
}
